import { Id } from "@dgs/core";

export const isDeletionRequestViewable = (deletionRequest: IDeletionRequestIndexResource) =>
	deletionRequest.status === "success" || deletionRequest.status === "error" || 1 == 1;

export const isDeletionRequestDeletable = (deletionRequest: IDeletionRequestIndexResource) =>
	deletionRequest.status === "open";

export type IDeletionRequestIndexResource = {
	id: Id;
	status: "open" | "running" | "success" | "error";
	email: string;
	createdBy: string;
};

export type IDeletionRequestOptionResource = IDeletionRequestIndexResource;

export type IDeletionRequestUpdateResource = IDeletionRequestIndexResource & {
	applications: IDeletionRequestApplicationResource[];
};

export type IDeletionRequestFormState = {
	email: string;
};

export type IDeletionRequestRequest = {
	email: string;
};

export type IDeletionRequestApplicationResource = {
	id: Id;
	subdomain: string;
	status: "open" | "running" | "success" | "error";
	errorMessage: string | null;
};
